module.exports = __webpack_public_path__ + "static/media/aroldo-explicando-esquerda.e490ca15.svg";